import { IconWrapper } from '../runtime';
export default IconWrapper('h3', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.292 9.31649C12.4667 9.12126 12.7189 8.99969 13.0002 8.99969C13.5249 8.99969 13.9502 9.42502 13.9502 9.94969C13.9502 10.4744 13.5249 10.8997 13.0002 10.8997C13.0002 10.8997 13.0002 10.8997 13.0002 10.8997C12.6965 10.8997 12.4502 11.1459 12.4502 11.4497C12.4502 11.7534 12.6964 11.9997 13.0002 11.9997C13.2439 11.9997 13.465 12.0907 13.6334 12.2415C13.8286 12.4162 13.9502 12.6684 13.9502 12.9497C13.9502 13.4744 13.5249 13.8997 13.0002 13.8997C12.4755 13.8997 12.0502 13.4744 12.0502 12.9497C12.0502 12.6459 11.804 12.3997 11.5002 12.3997C11.1964 12.3997 10.9502 12.6459 10.9502 12.9497C10.9502 14.0819 11.868 14.9997 13.0002 14.9997C14.1324 14.9997 15.0502 14.0819 15.0502 12.9497C15.0502 12.3574 14.7983 11.8232 14.3975 11.4497C14.7991 11.0755 15.0502 10.5419 15.0502 9.94969C15.0502 8.8175 14.1324 7.89969 13.0002 7.89969C12.393 7.89969 11.8469 8.16437 11.4723 8.58289C11.1481 8.9452 10.9502 9.425 10.9502 9.94969C10.9502 10.2534 11.1965 10.4997 11.5002 10.4997C11.804 10.4997 12.0502 10.2534 12.0502 9.94969C12.0502 9.70602 12.1412 9.48493 12.292 9.31649Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 1.75363V14.2497M9.25 1.75363V14.2497M1.75 8.00168H9.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});